import { Typography } from "@mui/material";

function FinanceDashboard() {
    return ( <Typography variant="h6"> Finance Dashboard</Typography> );
}

export default FinanceDashboard;